<div class="card dialog-box">
  <div class="card-header">
    Checkpoint Patrols Report
    @if (siteData?.company_name || clientData?.company_name) {
      <span>
        for
        <span class="fw-semibold">{{
          siteData?.company_name || clientData?.company_name
        }}</span>
      </span>
    }

    <span class="float-end ms-2" (click)="onCloseDialogue()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>

  @if (currentStep === 1) {
    <form [formGroup]="schedulerForm">
      <div class="row row-cols-1 g-3">
        <div class="form-floating">
          <input
            class="form-control"
            formControlName="name"
            type="text"
            placeholder="Report Name"
            required
            id="description"
            [class.is-invalid]="schedulerForm.controls['name'].invalid"
          />
          <label for="description">Report Name</label>
          @if (
            schedulerForm.controls["name"].invalid &&
            schedulerForm.controls["name"].touched
          ) {
            <div class="text-danger small">Please provide a report name</div>
          }
        </div>
        <div class="d-flex justify-content-center my-2">
          @for (option of repeatTypes; track option) {
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                formControlName="repeat_type"
                [readOnly]="scheduleData"
                [attr.disabled]="scheduleData"
                [value]="option.value"
                id="{{ option.value }}"
                (change)="checkRepeatType()"
              />
              <label class="form-check-label" for="{{ option.value }}">{{
                option.label
              }}</label>
            </div>
          }
        </div>
        <div class="form-floating">
          <input
            class="form-control"
            type="time"
            formControlName="mail_time"
            pattern="[0-9]{2}:00"
            title="Enter time in HH:00 format"
            id="mail_time"
            step="3600"
            (change)="formatMailTime($event)"
          />
          <label for="mail_time">Time of Day</label>
        </div>
        @if (!scheduleData) {
          <div class="form-floating">
            <input
              class="form-control"
              type="date"
              formControlName="start_day"
              id="start_day"
              placeholder="Start Date"
              [min]="startDate"
              [readOnly]="scheduleData"
              [attr.disabled]="scheduleData"
              (change)="checkRepeatType()"
            />
            <label for="start_day">Start Date</label>
          </div>
        }
        <div class="col">
          <div class="row row-cols-auto column-gap-3">
            <div class="col">
              <label for="summaryOnlyField">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="summaryOnlyField"
                  formControlName="summary_only"
                  (change)="onShowEventsChange($event, 'summary_only')"
                />
                Summary Only</label
              >
            </div>
            <div class="col">
              <label for="checkPointLocationShow">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkPointLocationShow"
                  formControlName="show_checkpoint_scan_location"
                  (change)="
                    onShowEventsChange($event, 'show_checkpoint_scan_location')
                  "
                />
                Show Scan Locations (QR/NFC)</label
              >
            </div>
            <div class="col">
              <label for="hideGuardNameCheckBox">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="hideGuardNameCheckBox"
                  formControlName="hide_guard_column"
                  (change)="onShowEventsChange($event, 'hide_guard_column')"
                />
                Hide Guard Names</label
              >
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row row-cols-2 mt-3">
      @if (scheduleData) {
        <div class="col">
          <button
            class="btn btn-danger btn-lg w-100"
            type="button"
            (click)="deleteSchdeule()"
          >
            Delete
          </button>
        </div>
      } @else {
        <div class="col">
          <button (click)="onCloseDialogue()" class="btn btn-dark btn-lg w-100">
            Cancel
          </button>
        </div>
      }
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="currentStep = 2"
          [disabled]="!schedulerForm.valid"
        >
          Add / Edit Recipients
        </button>
      </div>
    </div>
  }
  @if (currentStep === 2) {
    <div class="mb-4">
      <gtapp-auto-complete
        [data]="contactLookupList"
        placeHolder="Send Reports To"
        searchKeyword="user_full_name"
        [itemTemplate]="reportRecipientLookupTemplate"
        [addInitialKey]="true"
        (inputChanged)="contactLookup($event)"
        (selected)="addUserToSelected($event)"
      >
      </gtapp-auto-complete>
      <ng-template #reportRecipientLookupTemplate let-user>
        @if (user?.key === 0) {
          <div>Add New Contact</div>
        } @else {
          <div>
            {{ user?.user_full_name }}
            @if (user?.location_contact_id) {
              <div text="Onsite Contact" class="badge"></div>
            }
            <div>
              <small>
                {{ user?.user_full_name ? user.user_email : "" }}
                {{
                  user?.user_mobile_number
                    ? " , " + user?.user_mobile_number
                    : ""
                }}
              </small>
            </div>
          </div>
        }
      </ng-template>
    </div>

    <div class="row row-cols-1 row-cols-lg-2 row-cols-xxl-3 mb-4">
      @if (clientContactList?.length > 1) {
        <div class="col-12 col-lg-12 col-xxl-12 text-primary form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="selectedUsers?.length === clientContactList?.length"
            (change)="selectAllContactReportRecipients($event)"
            id="selectAllBox"
          />
          <label for="selectAllBox"
            >Select All [{{ clientContactList?.length }}]</label
          >
        </div>
      }
      @for (contact of clientContactList; track contact; let i = $index) {
        <div class="col form-check" (click)="addRemoveUser(contact)">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="contact?.selected"
            id="check-{{ contact.id }}-{{ i }}"
          />
          <label class="form-check-label" for="check-{{ contact.id }}-{{ i }}">
            {{ contact?.user_full_name || contact?.full_name }}
            @if (contact?.is_site_contact) {
              <span class="small-font text-secondary">[Site Contact]</span>
            }
            <div class="small-font">
              {{ contact?.user_email || contact?.email }}
              {{
                contact?.user_mobile_number
                  ? " , " + contact?.user_mobile_number
                  : ""
              }}
            </div>
          </label>
        </div>
      }
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button (click)="currentStep = 1" class="btn btn-dark btn-lg w-100">
          Back
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="!schedulerForm.valid || !selectedUsers?.length"
          type="button"
          (click)="scheduleData ? updateSchedule() : saveSchedule()"
        >
          {{ scheduleData ? "Update Schedule" : "Create Schedule" }}
        </button>
      </div>
    </div>
  }
</div>
